export default {
      id: "ic-plan-sport-usage",
      viewBox: "0 0 40 40",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-plan-sport-usage",
      toString: function () {
        return this.url;
      }
    }